'use client';
import clsx from 'clsx';
import Image from 'next/image';
import placeholder from 'public/images/placeholder.png';
import { useRef } from 'react';

type BaseCompPropsType = {
  children?: React.ReactNode;
  className?: string;
};

type CardProps = BaseCompPropsType & {
  direction?: 'flex-row' | 'flex-col' | 'flex-row-reverse' | 'flex-col-reverse';
};

export default function Card({ children, direction = 'flex-row', className }: CardProps) {
  return (
    <div
      className={clsx(
        'flex flex-col rounded-b-[16px] border-light-line-secondary bg-white md:h-[240px] md:flex-row md:rounded-[16px] md:border',
        direction,
        className
      )}
    >
      {children}
    </div>
  );
}

type CardContentProps = BaseCompPropsType;

export function CardContent({ children, className }: CardContentProps) {
  return <div className={className}>{children}</div>;
}

type CardMediaProps = {
  url: string;
  className?: string;
  alt?: string;
};

export function CardMedia({ url, className, alt }: CardMediaProps) {
  const ref = useRef(false);
  const handleImageError = (e: any) => {
    if (ref.current) return;
    e.target.src = placeholder.src;
    ref.current = true;
  };

  return (
    <Image
      width={480}
      height={240}
      alt={alt || 'banner'}
      src={url || placeholder.src}
      className={className}
      onErrorCapture={handleImageError}
      unoptimized
    />
  );
}
